import { create } from "zustand";

export const MAX_POINTS = 8000;

export interface LiveScanFrame {
  type: "live_scan";
  assetId: string;
  seq: number;
  frame: "map" | "camera";   // "camera" = rendered camera-frame (no pose / not localized)
  pose: { x: number; z: number; yaw: number } | null;   // null when the camera isn't localized
  points: number[];          // flat [x,z,...] in twin metres
  pointCount: number;
  intensity: number[];
}

interface MappingScanState {
  positions: Float32Array;   // MAX_POINTS * 3, (x,0,z) — preallocated, mutated in place
  count: number;             // valid points
  version: number;           // bump → r3f sets needsUpdate + drawRange
  pose: { x: number; z: number; yaw: number } | null;
  hz: number;
  lastFrameMs: number;
  applyFrame: (f: LiveScanFrame) => void;
  reset: () => void;
}

export const useMappingScanStore = create<MappingScanState>((set, get) => ({
  positions: new Float32Array(MAX_POINTS * 3),
  count: 0,
  version: 0,
  pose: null,
  hz: 0,
  lastFrameMs: 0,
  applyFrame(f) {
    const s = get();
    const pos = s.positions;
    const n = Math.min(f.pointCount, MAX_POINTS);
    for (let i = 0; i < n; i++) {
      pos[i * 3] = f.points[i * 2];
      pos[i * 3 + 1] = 0;
      pos[i * 3 + 2] = f.points[i * 2 + 1];
    }
    const now = Date.now();
    const dt = s.lastFrameMs ? (now - s.lastFrameMs) / 1000 : 0;
    set({
      count: n,
      pose: f.pose,
      version: s.version + 1,
      lastFrameMs: now,
      hz: dt > 0 ? 0.7 * s.hz + 0.3 * (1 / dt) : s.hz,
    });
  },
  reset() {
    set({ count: 0, version: 0, pose: null, hz: 0, lastFrameMs: 0 });
  },
}));
